import { MarriageAnscNotificationsResidentMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchMarriageNotificationsCivilStatusShared from 'shell/components/shared/ansc-notifications/research-marriage';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchMarriageNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageNotificationsCivilStatusShared
        scope={IdAmbito.Mutazioni}
        items={MarriageAnscNotificationsResidentMutationCrumbs()}
      />
    </Fragment>
  );
};

ResearchMarriageNotificationsCivilStatusPage.displayName =
  'Research Marriage Notifications CivilStatusPage component';

export default ResearchMarriageNotificationsCivilStatusPage;
